module.exports = __webpack_public_path__ + "img/truck-pickup.5ec06da7.svg";